/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { organizationsGet } from "../../funcs/organizationsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1OrganizationIdRequest$inboundSchema,
};

export const tool$organizationsGet: ToolDefinition<typeof args> = {
  name: "organizations_get",
  description: `Get organization details

Retrieves details of a specific organization`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await organizationsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
